export default __webpack_public_path__ + "static/media/kfi.731034ae.svg";